<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "UndoCountdown" });
import "tailwindcss/tailwind.css";
import { Button } from "../../elements/index.js";
import ProgressLine from "../progress-line/ProgressLine.svelte";
import { abortUndo, UNDO_LIST } from "../../stores/undo.js";
</script>

{#if Array.isArray($UNDO_LIST) && $UNDO_LIST.length > 0}

    <ul>
        {#each $UNDO_LIST as { key, label, isAborted, progress } }
            {#if !isAborted}
                <li>
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                    <span>{ @html label }</span>
                    <ProgressLine progress = { progress } mode = 'dark' />
                    <Button label = 'Abort' on:click = { abortUndo.bind(null, key) } size = 'xs' color = 'dark'/>
                </li>
            {/if}
        {/each}
    </ul>

{/if}

<style>

    ul {
        position: fixed;
        bottom: 20px;
        right: 20px;
        left: 20px;
        z-index: 50;
    }

        ul li {
            margin-top: 10px;
            box-shadow: 0 3px 4px 0px rgba(39,39,17,0.12),
                inset 0 -1px 1px 0px rgba(0, 0, 0, 0.24),
                inset 0 1px 1px 0px rgba(255, 255, 255, 0.12);
            border-radius: 5px;
            padding: 10px;
            display: flex;
            -moz-column-gap: 20px;
                 column-gap: 20px;
            align-items: center;
            color: #fff;
            background-color: #446083;
        }

        ul li :global(> div) {
                flex: 1;
                height: 1px !important;
            }

        ul li span  {
                flex-basis: auto;
            }

        ul li :global(button) {
                flex: 0 0 80px;
            }</style>